import ApplicationsEmployment from '../Applications/ApplicationsEmployment';
import ApplicationsNonEmploymentIncome from '../Applications/ApplicationsNonEmploymentIncome';

export default class CustomerEmployment {
	currentEmployment?: ApplicationsEmployment;
	employmentStatus?: string; // e.g., employed, retired, etc.
	nonEmployedStatusStartDate?: Date;
	incomeSituationDescription?: string;
	employeeType?: string; // e.g., w2, 1099
	previousEmployment: ApplicationsEmployment = new ApplicationsEmployment();
	socialSecurity?: ApplicationsNonEmploymentIncome;
	pension?: ApplicationsNonEmploymentIncome;
	supplementalSecurity?: ApplicationsNonEmploymentIncome;
	studentSchoolName?: string;
	investment?: ApplicationsNonEmploymentIncome;
	otherIncome?: ApplicationsNonEmploymentIncome;
	monthlyGrossSalary?: number;
	movedInDate?: Date;
	constructor(init?: Partial<CustomerEmployment>) {
		if (init) {
			this.currentEmployment = init.currentEmployment;
			this.employmentStatus = init.employmentStatus;
			this.nonEmployedStatusStartDate = init.nonEmployedStatusStartDate;
			this.incomeSituationDescription = init.incomeSituationDescription;
			this.employeeType = init.employeeType;
			this.previousEmployment = init.previousEmployment;
			this.socialSecurity = init.socialSecurity;
			this.pension = init.pension;
			this.supplementalSecurity = init.supplementalSecurity;
			this.studentSchoolName = init.studentSchoolName;
			this.investment = init.investment;
			this.otherIncome = init.otherIncome;
			this.monthlyGrossSalary = init.monthlyGrossSalary;
			this.movedInDate = init.movedInDate;
		}
	}
}
